export default [
    { id: 'DashboardDetails', label: 'Dashboard Details', parent: 'DashboardMaintenanceEnquiry' },
    { id: 'DashboardLayout', label: 'Dashboard Layout', parent: 'DashboardMaintenanceEnquiry' },
    { id: 'QuickLinks', label: 'Quick Links', parent: 'DashboardMaintenanceEnquiry' },
];
